import { roleTheme, previewTheme, type RoleTone } from '../styles/theme';

/** The role a person holds, or a role in the Roles table. */
export function RolePill({ tone, label }: { tone: RoleTone; label: string }) {
  const t = roleTheme[tone];
  return (
    <span
      style={{
        display: 'inline-block',
        maxWidth: '100%',
        fontSize: 12,
        fontWeight: 700,
        padding: '5px 14px',
        borderRadius: 999,
        background: t.bg,
        color: t.fg,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      {label}
    </span>
  );
}

/**
 * Says a panel's API routes do not exist yet on the API it is talking to, so it
 * shows nothing — never sample rows. The same amber the conversation panel
 * uses, so "not wired up" reads the same everywhere and is never mistaken for
 * "empty".
 */
export function PreviewPill({ children = 'Preview · not wired to the API yet' }: { children?: string }) {
  return (
    <span
      style={{
        fontSize: 11,
        fontWeight: 800,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        padding: '5px 12px',
        borderRadius: 999,
        background: previewTheme.pill.bg,
        color: previewTheme.pill.fg,
        whiteSpace: 'nowrap',
      }}
    >
      {children}
    </span>
  );
}
